import { render, staticRenderFns } from "./addSubject.vue?vue&type=template&id=0500ba35"
import script from "./addSubject.vue?vue&type=script&lang=js"
export * from "./addSubject.vue?vue&type=script&lang=js"
import style0 from "./addSubject.vue?vue&type=style&index=0&id=0500ba35&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports